import { render, staticRenderFns } from "./home-office-index.vue?vue&type=template&id=70d8a59c"
import script from "./home-office-index.vue?vue&type=script&lang=js"
export * from "./home-office-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports